import { IRadioOption } from '../../../app/components'
import {
  CategoriaNotificacaoType,
  DispositivoType,
  DocumentoPessoaType,
  FatorRiscoType,
  NotificacaoType,
  SituacaoDiagnosticoType,
  SituacaoNota,
  VinculoType,
} from '../enums'
import { MaskType } from '../enumsUI'

const QUERIES = {
  USERS_LIST: 'users-list',
  FUNCIONARIOS_LIST: 'funcionarios-list',
  PACIENTE_LIST: 'paciente-list',
  PACIENTE_HISTORICO_LIST: 'paciente-historico-list',
  EMPRESAS_LIST: 'empresas-list',
  CLIENTES_CONTRATOS_LIST: 'clientes-contratos-list',
  UNIDADES_LIST: 'unidades-list',
  EMPRESAS_CLIENTE_LIST: 'empresas-cliente-list',
  API_EMPRESAS_LIST: 'api-empresas-list',
  EMPRESA_CLIENTE_COORDENADORES_LIST: 'empresa-cliente-coordenadores-list',
  EMPRESA_CLIENTE_SETORES_LIST: 'empresa-cliente-setores-list',
  EMPRESA_CLIENTE_CARGOS_LIST: 'empresa-cliente-cargos-list',
  EMPRESA_CLIENTE_RISCO_LIST: 'empresa-cliente-risco-list',
  EMPRESA_CLIENTE_EXAME_LIST: 'empresa-cliente-exame-list',
  ESPECIALIDADES_LIST: 'especialidades-list',
  ATENDIMENTO_MEDICO_LIST: 'atendimento-medico-list',
  MEUS_ATENDIMENTOS_LIST: 'meus-atendimentos-list',
  MEUS_ATENDIMENTOS_RESUMO: 'meus-atendimentos-resumo',
  DOWNLOAD_ASO_LIST: 'download-aso-list',
  ATENDIMENTO_GESTAO_LIST: 'atendimento-gestao-list',
  RELATORIO_ATENDIMENTOS_LIST: 'relatorio-atendimentos-list',
  ATENDIMENTO_MEDICO_GENERATE_LIST: 'atendimento-medico-generate-list',
  ATENDIMENTO_MEDICO_SIGN_LIST: 'atendimento-medico-sign-list',
  ESUS_ENVIOS_LIST: 'esus-envios-list',
  SNCR_CONTEXTO: 'sncr-contexto',
  SNCR_BLOCOS_LIST: 'sncr-blocos-list',
  SNCR_NUMEROS_LIST: 'sncr-numeros-list',
  IMPORTACOES_LIST: 'importacoes-list',
  IMPORTACOES_ERROS_LIST: 'importacoes-erros-list',
  IMPORTACOES_DETALHES_LIST: 'importacoes-detalhes-list',
  FORMULARIOS_LIST: 'formularios-list',
  AVALIACOES_LIST: 'avaliacoes-list',
  AVALIACOES_PENDENTES_LIST: 'avaliacoes-pendentes-list',
  VINCULOS_ESPECIALIDADE_LIST: 'vinculos-especialidade-list',
  VINCULOS_ATENDIMENTO_LIST: 'vinculos-atendimento-list',
  LOGS_CONSULTA: 'logs-consulta',
  LOGS_CONSULTA_DETALHE: 'logs-consulta-detalhe',
  LOGS_USUARIO: 'logs-usuario',
  LOGS_USUARIO_DETALHE: 'logs-usuario-detalhe',
  NPS_LIST: 'nps-list',
  INDICADORES_OPERACIONAIS: 'indicadores-operacionais',
  INDICADORES_QUALIDADE: 'indicadores-qualidade',
  INDICADORES_PERFORMANCE: 'indicadores-performance',
  ESPECIALISTAS_LIST: 'especialistas-list',
  TELEKITS_LIST: 'telekits-list',
  TELEKIT_ALOCACOES: 'telekit-alocacoes',
  DISPOSITIVOS_GESTAO_LIST: 'dispositivos-gestao-list',
  FORNECEDORES_LIST: 'fornecedores-list',
  MODELOS_LIST: 'modelos-list',
  PRESCRICOES_LIST: 'prescricoes-list',
  PARECERES_LIST: 'pareceres-list',
  INTERCONSULTA_RATC_LIST: 'interconsulta-ratc-list',
  MONITORAMENTO_LIST: 'monitoramento-list',
  PEGA_PLANTAO: 'pega_plantao',
  EMPRESAS_VALORES_LIST: 'empresas-valores-list',
  ENDERECOS_LIST: 'enderecos-list',
  PROFISSIONAL_VALORES_LIST: 'profissional-valores-list',
  ATENDIMENTOS_NAO_FATURADOS_LIST: 'atendimentos-nao-faturados-list',
  FATURAS_LIST: 'faturas-list',
  FATURAS_RESPONSAVEL_LIST: 'faturas-responsavel-list',
  FATURAS_ATENDIMENTOS_LIST: 'faturas-atendimentos-list',
  FATURAS_PROFISSIONAL_LIST: 'faturas-profissional-list',
  FATURAS_PROFISSIONAL_ATENDIMENTOS_LIST: 'faturas-profissional-atendimentos-list',
  NOTAS_LIST: 'notas-list',
  NOTAS_ATENDIMENTOS_LIST: 'notas-atendimentos-list',
  MEDICAMENTOS_LIST: 'medicamentos-list',
  EXAMES_LIST: 'exames-list',
  GRUPOS_LIST: 'grupos-list',
  USUARIOS_LIST: 'usuarios-list',
  TERMOS_LIST: 'termos-list',
  NOTAS_VERSAO_LIST: 'notas-versao-list',
  NOTAS_VERSAO_VIGENTE: 'notas-versao-vigente',
  NOTAS_VERSAO_HISTORICO: 'notas-versao-historico',
  NOTIFICACOES_LIST: 'notificacoes-list',
  NOTIFICACOES_NAO_LIDAS_COUNT: 'notificacoes-nao-lidas-count',
  NOTIFICACOES_ENVIADAS_LIST: 'notificacoes-enviadas-list',
  ESCALAS_PESSOAIS_LIST: 'escalas-pessoais-list',
  ESCALAS_PESSOAL_AGENDA: 'escalas-pessoal-agenda',
  ESCALAS_EMPRESA_LIST: 'escalas-empresa-list',
  ESCALAS_EMPRESA_AGENDA: 'escalas-empresa-agenda',
  FERIADOS_LIST: 'feriados-list',
  AGENDA_DISPONIBILIDADE: 'agenda-disponibilidade',
}

export const DocumentoPessoaLabels: Record<DocumentoPessoaType, string> = {
  [DocumentoPessoaType.Cpf]: 'Cadastro de Pessoa Física',
  [DocumentoPessoaType.Cns]: 'Cartão Nacional de Saúde',
  [DocumentoPessoaType.Rg]: 'Carteira de Identidade',
  [DocumentoPessoaType.Ctps]: 'Carteira de Trabalho',
  [DocumentoPessoaType.Passaporte]: 'Passaporte',
  [DocumentoPessoaType.BilheteIdentidadeAngola]: 'Bilhete de Identidade (Angola)',
}

export const VinculoLabels: Record<VinculoType, string> = {
  [VinculoType.Lauduz]: 'Vínculo com a Lauduz',
  [VinculoType.Cliente]: 'Vínculo com o Cliente',
}

export const FatoresRiscosLabels: Record<FatorRiscoType, string> = {
  [FatorRiscoType.Acidente]: 'Acidente',
  [FatorRiscoType.Biologico]: 'Biológico',
  [FatorRiscoType.Ergonomico]: 'Ergonômico',
  [FatorRiscoType.Fisico]: 'Físico',
  [FatorRiscoType.Psicossocial]: 'Psicossocial',
  [FatorRiscoType.Quimico]: 'Químico',
  [FatorRiscoType.Sem_Risco]: 'Sem risco',
}

export const dispositivosLabels: Record<DispositivoType, string> = {
  [DispositivoType.Balanca]: 'Balança',
  [DispositivoType.Oximetro]: 'Oxímetro',
  [DispositivoType.Termometro]: 'Termômetro',
  [DispositivoType.Pressao]: 'Pressão Arterial',
  [DispositivoType.Camera]: 'Câmera',
  [DispositivoType.Otoscopio]: 'Otoscópio',
  [DispositivoType.Inspecao]: 'Inspeção Visual',
  [DispositivoType.Glicosimetro]: 'Glicosímetro',
  [DispositivoType.Estetoscopio]: 'Estetoscópio',
  [DispositivoType.Retinografo]: 'Retinógrafo',
  [DispositivoType.Doppler]: 'Doppler',
  [DispositivoType.Oftalmoscopio]: 'Oftalmoscópio',
  [DispositivoType.Dermatoscopio]: 'Dermatoscópio',
  [DispositivoType.Ecg]: 'ECG',
}

export const situacaoDiagnosticoLabels: Record<SituacaoDiagnosticoType, string> = {
  [SituacaoDiagnosticoType.Sem_Diagnostico]: 'Sem diagnóstico fechado',
  [SituacaoDiagnosticoType.Em_Investigacao]: 'Diagnóstico em investigação',
  [SituacaoDiagnosticoType.Diagnosticado]: 'Diagnosticado',
}

export const situacaoNotaLabels: Record<SituacaoNota, string> = {
  [SituacaoNota.Aguardando_Nota]: 'Aguardando nota',
  [SituacaoNota.Aguardando_Pagamento]: 'Aguardando pagamento',
  [SituacaoNota.Nota_Recebida]: 'Nota recebida',
  [SituacaoNota.Paga]: 'Paga',
  [SituacaoNota.Processamento]: 'Em processamento',
  [SituacaoNota.Analise]: 'Em análise',
  [SituacaoNota.Cancelada]: 'Cancelada',
}

export const MaskPatterns: Record<
  MaskType,
  string | { mask: string; overwrite: boolean; lazy: boolean }[]
> = {
  [MaskType.Phone]: [
    { mask: '(00) 0000-0000', overwrite: true, lazy: true },
    { mask: '(00) 0 0000-0000', overwrite: true, lazy: true },
  ],
  [MaskType.CpfCns]: [
    { mask: '000.000.000-00', overwrite: true, lazy: true },
    { mask: '000 0000 0000 0000', overwrite: true, lazy: true },
  ],
  [MaskType.CPF]: '000.000.000-00',
  [MaskType.CNPJ]: '00.000.000/0000-00',
  [MaskType.CEP]: '00.000-000',
  [MaskType.CNS]: '000 0000 0000 0000',
  [MaskType.CNES]: '0000000',
  [MaskType.CAEPF]: '000.000.000/000-00',
  [MaskType.CRM]: '0000000000',
  [MaskType.RQE]: '000000',
  [MaskType.RG]: '000000000000000',
  [MaskType.CTPS_Numero]: '000000000000000',
  [MaskType.CTPS_Serie]: '000.00000.00-0',
  [MaskType.Matricula]: '000000000000000',
  [MaskType.Custom]: '',
}

export const ESTADOS_ATENDIMENTO_FIXOS = [
  {
    nome: 'Aguardando',
    descricao: 'Aguardando atendimento',
    ativo: true,
    id: 1,
  },
  {
    nome: 'Iniciado',
    descricao: 'Em atendimento',
    ativo: true,
    id: 2,
  },
  {
    nome: 'Pendente',
    descricao: 'Atendimento com pendência',
    ativo: true,
    id: 7,
  },
  {
    nome: 'Finalizado',
    descricao: 'Atendimento finalizado',
    ativo: true,
    id: 3,
  },
  {
    nome: 'Cancelado',
    descricao: 'Atendimento Cancelado',
    ativo: true,
    id: 5,
  },
  {
    nome: 'Falta',
    descricao: 'Paciente não compareceu',
    ativo: true,
    id: 4,
  },
  {
    nome: 'Retorno de pendência',
    descricao: 'Atendimento com pendência resolvida',
    ativo: true,
    id: 6,
  },
]

export const CategoriaNotificacaoLabels: Record<CategoriaNotificacaoType, string> = {
  [CategoriaNotificacaoType.Geral]: 'Geral',
  [CategoriaNotificacaoType.Atendimento]: 'Atendimento',
  [CategoriaNotificacaoType.Financeiro]: 'Financeiro',
  [CategoriaNotificacaoType.Sistema]: 'Sistema',
}

export const notificacaoOptions: IRadioOption<NotificacaoType | null>[] = [
  {
    id: 'nenhum',
    descricao: 'Não notificar',
    value: null,
  },
  {
    id: 'email',
    descricao: 'E-mail',
    value: NotificacaoType.Email,
  },
  {
    id: 'whats',
    descricao: 'WhatsApp',
    value: NotificacaoType.Whatsapp,
  },
  {
    id: 'ambos',
    descricao: 'Email e WhatsApp',
    value: NotificacaoType.Ambos,
  },
]

export { QUERIES }
